export default __webpack_public_path__ + "static/24-abc6fc2f2ab1c793bf5c5d3349de12e9.jpg";